var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8076 8.12297L13.1618 9.47713L15.8701 6.7688",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8083 14.8938V13.5396C11.8083 12.8213 11.5229 12.1325 11.015 11.6246C10.5071 11.1166 9.81823 10.8313 9.09993 10.8313H5.03743C4.31914 10.8313 3.63027 11.1166 3.12235 11.6246C2.61444 12.1325 2.3291 12.8213 2.3291 13.5396V14.8938",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06868 8.12297C8.56446 8.12297 9.77702 6.9104 9.77702 5.41463C9.77702 3.91886 8.56446 2.7063 7.06868 2.7063C5.57291 2.7063 4.36035 3.91886 4.36035 5.41463C4.36035 6.9104 5.57291 8.12297 7.06868 8.12297Z",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total-users.e1a05e686200008449334cb1a92ec858.svg";
export { ForwardRef as ReactComponent };